import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail, FileText, LucideMoveUpRight } from "lucide-react";
import "./help-and-support.css";

const HelpAndSupport = () => {
  const navigate = useNavigate();

  const handleEmailClick = () => {
    window.open("https://mail.google.com/mail/?view=cm&fs=1&to=provider@syndicate.bio", "_blank");
  };

  const handleContactFormClick = () => {
    navigate("/contact-form");
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.1,
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    },
  };

  const headingVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20, scale: 0.95 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
        delay: i * 0.1,
      },
    }),
    hover: { scale: 1.02, transition: { duration: 0.2 } },
    tap: { scale: 0.98, transition: { duration: 0.1 } },
  };

  const arrowVariants = {
    hover: {
      x: 5,
      transition: { type: "spring", stiffness: 400, damping: 10 },
    },
  };

  return (
    <motion.div
      className="help-and-support-container"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="help-and-support-content">
        <motion.h1 variants={headingVariants}>Help & support</motion.h1>
        <motion.p
          className="subtitle"
          variants={headingVariants}
          transition={{ delay: 0.1 }}
        >
          Do you require assistance? We are ready to help.
        </motion.p>
        <motion.div className="support-options" variants={containerVariants}>
          <motion.div
            className="support-card"
            onClick={handleEmailClick}
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            whileHover="hover"
            whileTap="tap"
            custom={0}
          >
            <svg
              className="support-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 8V2L10 4"
                stroke="#3A3F6A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 2L14 4"
                stroke="#3A3F6A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 12C3 12 3 13.79 3 16V17C3 19.76 3 22 8 22H16C20 22 21 19.76 21 17V16C21 13.79 21 12 17 12C16 12 15.72 12.21 15.2 12.6L14.18 13.68C13 14.94 11 14.94 9.81 13.68L8.8 12.6C8.28 12.21 8 12 7 12Z"
                stroke="#3A3F6A"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 11.9991V9.99906C5 7.98906 5 6.32906 8 6.03906"
                stroke="#3A3F6A"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19 11.9991V9.99906C19 7.98906 19 6.32906 16 6.03906"
                stroke="#3A3F6A"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <h2>Send us an email</h2>
            <motion.div variants={arrowVariants} className="arrow">
              <LucideMoveUpRight size={20} />
            </motion.div>
          </motion.div>
          <motion.div
            className="support-card"
            onClick={handleContactFormClick}
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            whileHover="hover"
            whileTap="tap"
            custom={1}
          >
            <svg
              className="support-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
                stroke="#3A3F6A"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.9945 11H16.0035"
                stroke="#3A3F6A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.9945 11H12.0035"
                stroke="#3A3F6A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.99451 11H8.00349"
                stroke="#3A3F6A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <h2>Fill contact form</h2>
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default HelpAndSupport;